import getDatasourceByType from './utils/getDatasourceByType';
import filters from '../filters';
import sign from '../sign';
import performanceReport from '@tencent/qd-lib/es/performanceReport';

function newPromise(list) {
    return new Promise((resolve) => {
        resolve(list);
    });
}

export default function (config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'Recent',
            moreConfig: config,
            searchField: ["showName", "nickName", "remarkName", "account"]
        })
            .then((list) => {
                console.log('App getDatasourceByType Recent', list);
                performanceReport.reportPcFirstScreen('[新]关系链选择器');
                let newList = [];
                let filter = null;
                let hidden = null;
                try {
                    filter = selfConfig.filter ? new Set(selfConfig.filter) : null;
                } catch (err) {
                    // no code
                }
                try {
                    hidden = selfConfig.hidden ? new Set(selfConfig.hidden) : null;
                } catch (err) {
                    // no code
                }
                list.forEach((originItem) => {
                    const item = originItem;
                    newList.push(item);
                });

                // 黑名单，排除掉不需要展示的内容
                if (hidden) {
                    if (hidden.has('exttmp')) {
                        newList = newList.filter(item => !(item.userInfo && item.userInfo.sessionType === 'exttmp'));
                    }
                }

                // 白名单，过滤出需要展示的内容
                if (filter) {
                    newList = newList.filter(item => filter.has(item.metaSourceType));

                    if (filter.has('people') && !filter.has('troop') && !filter.has('discuss')) {
                        return filters.setKfuinTypeInList(newList);
                    }
                }
                return newPromise(newList);
            })
            .then((list) => {
                // 为单向关系链的联系人数据打标记
                const newList = sign.oneWayRelationshipChain(list, 'recent', selfConfig);
                resolve(newList);
            })
            .catch((err) => {
                reject(err);
            });
    });
}
